import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'app',
  imports: [RouterOutlet, NgxSpinnerModule],
  encapsulation: ViewEncapsulation.None,
  template: `
    <router-outlet></router-outlet>
    <ngx-spinner
      [fullScreen]="true"
      bdColor="rgba(255, 255, 255, 0.92)"
      color="transparent"
      type="ball-pulse"
      size="default"
    >
      <div class="cfpro-loader">
        <div class="cfpro-loader-ring"></div>
        <img src="images/logo.png" alt="Loading" class="cfpro-loader-logo" />
      </div>
    </ngx-spinner>
  `,
  styles: [`
    /* Hide default ngx-spinner dots */
    .ngx-spinner .la-ball-pulse {
      display: none !important;
    }

    .cfpro-loader {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      width: 120px;
      height: 120px;
    }

    .cfpro-loader-logo {
      width: 64px;
      height: auto;
      position: absolute;
      animation: cfpro-fade 1.8s ease-in-out infinite;
    }

    .cfpro-loader-ring {
      width: 120px;
      height: 120px;
      border-radius: 50%;
      border: 3px solid #e8efe9;
      border-top: 3px solid #043B22;
      border-right: 3px solid #76AA84;
      animation: cfpro-spin 1s linear infinite;
      position: absolute;
    }

    @keyframes cfpro-spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    @keyframes cfpro-fade {
      0%, 100% { opacity: 0.6; }
      50% { opacity: 1; }
    }
  `]
})
export class AppComponent implements OnInit {
  ngOnInit(): void {}
}
